export default function doesSupportWebShare() {
  return 'share' in navigator;
}
flarum.reg.add('davwheat-share', 'common/helpers/doesSupportWebShare', doesSupportWebShare);